// extracted by mini-css-extract-plugin
export default {"dropdownWithoutEllipsis":"Q7yVvfZj7kaWtgNIUks8"};